export default __webpack_public_path__ + "static/media/content1.1dc22c55.png";